<template>
    <div id="history" class="bg-gray-relative-100">
        <div class="pb-3">
            <SubHeader title="결제 상세 정보"></SubHeader>
        </div>
        <div class="px-3">
            <div class="p-3 mb-3 bg-body rounded-4 shadow-400">
                <div class="fs-px-15 lh-lg fw-bold flex-between-center">
                    <p class="" v-if="info.type == 'D'">
                        {{ addDay(info.date) }} {{ info.confirm_time }}
                    </p>
                    <p class="" v-if="info.type == 'R'">
                        {{ addDay(info.date) }}
                        <span v-if="info.status != 'H'">{{ info.confirm_time }}</span>
                        <span v-if="info.status == 'H'">{{ info.start_time }} ~ {{ info.end_time }}</span>
                    </p>
                </div>
                <div class="flex-between-center mb-2 flex-wrap fs-px-14">
                    <span class="badge badge-custom-1">{{ info.memo }} 코스</span>
                    <span class="" >
                        {{ info.proxy == 'N' ? '본인' : proxy_list[0].name }} <span v-if="info.people >1"> 외 {{ info.people - 1 }}명</span>
                    </span>
                </div>

                <div class="w-100 flex-between-center position-relative">
                    <div class="bg-img w-px-70 h-px-70 rounded-4 shadow flex-shrink-0" :style="{ backgroundImage: 'url(' + l_image_path + ')' }"></div>
                    <div class="txt_box small w-80 ps-3">
                        <p class="h6 fw-bold lh-lg" :class="{ 'text-success': info.status === 'Y', 'text-primary': info.status === 'P', 'text-gray-500': info.status === 'H', 'text-danger': info.status === 'C', 'text-warning': info.status === 'CP',}">
                            {{ info.status === 'Y' ? '결제 완료' : info.status === 'H' ? '결제 대기' : info.status === 'P' ? '결제 요청' : info.status === 'CP' ? '취소 요청' : '취소 완료'}}
                        </p>
                        <div class="d-flex gap-3 mb-1">
                            <p class="h6 fw-bold">{{ l_name }}</p>
                            <div class="text-gray-relative-600 flex-between-center w-50 pe-2">
                                <a :href="info.site_url" target="_blank">
                                    <i class="fas fa-link"></i>
                                </a>
                            </div>
                        </div>
                        <p class="lh-sm text-gray-relative-600">
                            <i class="far fa-map-marker-alt me-1"></i>{{ l_address }}
                        </p>
                    </div>

                    <div class="position-absolute end-0">
                        <span class="badge w-px-30 h-px-30 rounded-3 fw-normal fs-px-12 px-2 ms-3 d-flex flex-column align-items-center justify-content-center shadow-100 border" role="button" @click="$router.push(`/payment/receipt/${info.code}`)" v-if="info.status =='Y'">
                            <i class="fal fa-receipt text-muted"></i>
                        </span>
                    </div>
                </div>
                <div class="flex-between-center pt-3 fs-px-14" v-if="info.status === 'C'">
                    <small>결제 취소 일시</small>
                    <small class="small">{{ addDay(info.update_time) }}</small>
                </div>
                <hr />

                <div class="text-start fs-px-15 mb-3">
                    <div class="flex-between-center">
                        <b>총 결제 요청 금액</b>
                        <p role="button" @click="detailOpen = !detailOpen">
                            <b class="text-success" v-if="info.status !== 'C'">{{ CheckPrice(info.price) }} 원</b>
                            <b class="text-success" v-if="info.status === 'C'">-{{ CheckPrice(info.price) }} 원</b>
                            <i class="fas fa-sm text-gray-relative-500" :class="{ 'fa-chevron-down': !detailOpen, 'fa-chevron-up': detailOpen,}"></i>
                        </p>
                    </div>
                    <div v-show="detailOpen">
                        <div class="fs-px-13 flex-between-center" v-for="item in paymentDetailItems" :key="item.key">
                            <span class="ps-2">└ {{ item.name }}</span>
                            <p class="pe-3" v-if="info.status !== 'C'">
                                {{ item.price === null ? '-' : `${CheckPrice(item.price)} 원` }}
                            </p>
                            <p class="pe-3" v-if="info.status === 'C'">
                                {{ item.price === null ? '-' : `-${CheckPrice(item.price)} 원` }}
                            </p>
                        </div>
                    </div>
                </div>

                <div class="flex-between-center mb-3 fs-px-15" v-if="info.payment_type">
                    <b>결제수단</b>
                    <span>{{ PaymentTypeLabel(info.payment_type) }}</span>
                </div>

                <div class="text-start fs-px-15 mb-3" v-if="info.proxy == 'Y'">
                    <div class="flex-between-center">
                        <b>라운딩 참석자 (대리 결제)</b>
                    </div>
                    <div class="fs-px-13 flex-between-center" v-show="detailOpen">
                        <div class="w-50 d-flex flex-column">
                            <div class="d-flex gap-3" v-for="item in proxy_list" :key="item.no">
                                <span>{{ item.name }}</span>
                                <span>{{ phoneFormat(item.tel) }}</span>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="text-start fs-px-15 mb-3" v-show="info.other == 'Y'">
                    <div class="flex-between-center">
                        <b>기타 요청 사항</b>
                    </div>
                    <div class="fs-px-13 flex-between-center" v-show="detailOpen">
                        <span class="ps-2">
                            <span>{{ info.other_memo }}</span>
                        </span>
                    </div>
                </div>

                <div class="text-start fs-px-15 mb-3" v-show="info.status == 'C' || info.status == 'CP'">
                    <div class="flex-between-center">
                        <b>취소 사유</b>
                    </div>
                    <div class="fs-px-13 flex-between-center" v-show="detailOpen">
                        <span class="ps-2">
                            <span>{{ info.cancel_memo }}</span>
                        </span>
                    </div>
                </div>

                <div class="text-start fs-px-15 mb-3" v-if="info.status == 'CP'">
                    <div class="flex-between-center">
                        <b v-if="info.status == 'CP'">취소 요청 일시</b>
                    </div>
                    <div class="fs-px-13 flex-between-center" v-show="detailOpen">
                        <span class="ps-2">
                            <span>{{ addDay(info.update_time) }}</span>
                        </span>
                    </div>
                </div>
            </div>
            
            <div class="d-flex">
                <button class="btn btn-main thick w-100 btn-lg text-white shadow-sm me-2" @click="EditReservation()" v-if="info.status =='P'">결제요청 변경</button>
                <button class="btn btn-warning thick w-100 btn-lg text-white shadow-sm ms-2" @click="CancelReservation()" v-if="info.status !='C' && info.status !='Y' && info.status !=''">결제요청 취소</button>
                <button class="btn btn-danger thick w-100 btn-lg text-white shadow-sm ms-2" @click="CancelReservationRefund()" v-if="info.status =='Y'">결제요청 취소</button>
            </div>
            
        </div>
    </div>
</template>

<script>
import SubHeader from '@/components/common/SubHeader.vue';
import { format } from '@/mixins';
const CryptoJS = require('crypto-js');

export default {
    components: {
        SubHeader,
    },
    mixins: [format],
    data() {
        return {
            code: this.$route.params.code,
            detailOpen: true,
            refunding: false,   // 환불 요청 연타 방지
            info: {
                code: '',
                type: '',
                shop_code: '',
                location_code: '',
                member_code: '',
                date: '',
                start_time: '',
                end_time: '',
                confirm_time: '',
                people: 0,
                memo: '',
                price: 0,
                proxy: '',
                cart: '',
                other: '',
                other_memo: '',
                status: '',
                create_time: '',
                update_time: '',
                cancel_memo: null,
                user_name: '',
                location_name: '',
                location_address: '',
                site_url: '',
                payment_type: '',
            },
            l_name: '',
            l_address: '',
            l_image_path: '',
            item_list: [],
            proxy_list: [{ no: 0, name: '', tel: '' }],
            proxy_name: '',
        };
    },
    mounted() {
        this.GetReservation();
    },
    computed: {
        paymentDetailItems() {
            if (Array.isArray(this.item_list) && this.item_list.length > 0) {
                return this.item_list
                    .map((item, index) => {
                        const amount = Number(item.price);
                        if (!Number.isFinite(amount) || amount <= 0) {
                            return null;
                        }

                        const code = String(item.code || '').toUpperCase();
                        const nameMap = {
                            GREEN: '그린피',
                            CART: '카트비',
                            ETC: '기타',
                        };

                        return {
                            key: item.code || item.name || index,
                            name: item.name || nameMap[code] || '기타',
                            price: amount,
                        };
                    })
                    .filter(Boolean);
            }

            const fallbackPrice = Number(this.info.price);
            if (!Number.isFinite(fallbackPrice) || fallbackPrice <= 0) {
                return [];
            }

            const cartPriceCandidates = [
                this.info.cart_price,
                this.info.cartPrice,
                this.info.c_price,
                this.info.cart_amount,
                this.info.cartAmount,
            ];
            const cartPrice = cartPriceCandidates
                .map((value) => Number(value))
                .find((value) => Number.isFinite(value) && value > 0);

            if (this.info.cart == 'Y') {
                if (Number.isFinite(cartPrice) && cartPrice < fallbackPrice) {
                    return [
                        {
                            key: 'green-price',
                            name: '그린피',
                            price: fallbackPrice - cartPrice,
                        },
                        {
                            key: 'cart-price',
                            name: '카트비',
                            price: cartPrice,
                        },
                    ];
                }

                return [
                    {
                        key: 'green-price',
                        name: '그린피',
                        price: null,
                    },
                    {
                        key: 'cart-price',
                        name: '카트비',
                        price: null,
                    },
                ];
            }

            return [
                {
                    key: 'total-price',
                    name: '그린피',
                    price: fallbackPrice,
                },
            ];
        },
    },
    methods: {
        EditReservation(){
            const code = this.code;
            this.$router.push({path : `/reservation/edit/${code}`})
        },
        CheckPrice(price) {
            const amount = price * 1;
            return amount.toLocaleString();
        },
        PaymentTypeLabel(type) {
            const map = {
                P: '캐쉬',
                C: '지류상품권',
                CP: '지류상품권 & 캐쉬',
                K: '한국골프상품권',
                KP: '한국골프상품권 & 캐쉬',
                MIX: '상품권 & 카드/계좌',
            };
            return map[type] || '결제수단 미확인';
        },
        PaymentRefundNotice(type) {
            if (type === 'C' || type === 'K' || type === 'KP') {
                return '취소 시 상품권이 자동으로 복구됩니다.';
            } else if (type === 'MIX') {
                return '취소 시 소진된 상품권은 복구되고, 카드/계좌 결제분은 별도 환불 처리됩니다.';
            }
            return '자동환불되지 않는 결제수단입니다. 취소 후 운영팀에 수동 환불 요청이 필요합니다.';
        },
        CancelReservationRefund(){

            const notice = `결제수단: ${this.PaymentTypeLabel(this.info.payment_type)}<br>${this.PaymentRefundNotice(this.info.payment_type)}<br><br>결제를 취소하시겠습니까?`;

            this.$confirm(notice).then((result) => {
                if (result.isOk) {
                    const code = this.code;

                    
                    const body = { code };
                    const req = CryptoJS.AES.encrypt( JSON.stringify(body), process.env.VUE_APP_SECRET_TOKEN).toString();

                    // 연타 방지 — 환불 요청이 두 번 나가면 안 된다
                    if (this.refunding) return;
                    this.refunding = true;

                    this.$http.post('/shop/reservation/ReservationCancelRefund', { req }, { quiet: true }).then(
                        (res) => {
                            // ⚠️ 종전엔 성공(200/code=200)일 때만 화면을 갱신하고 실패는 **아무 반응이 없었다**.
                            //    담당자는 확인창까지 눌렀으니 처리된 줄 알고 고객에게 "취소됐다"고 안내하는데
                            //    실제로는 환불이 안 된 상태가 된다. 바로 옆 CancelReservation() 은 이미
                            //    실패 안내를 하고 있었다 — 돈이 걸린 이쪽만 빠져 있었다.
                            if (res.status != 200) {
                                this.$alert('취소 처리에 실패했습니다.<br>잠시 후 다시 시도해주세요.');
                                return;
                            }
                            if (res.data.code == '200') {
                                this.GetReservation();
                                this.$alert('결제요청이 취소되었습니다.');
                                return;
                            }
                            // 서버가 사유를 주면 그대로 보여준다(수동환불 안내 등)
                            this.$alert(res.data.message || '취소 처리에 실패했습니다.<br>고객센터로 문의해주세요.');
                        }
                    ).catch(() => {
                        this.$alert('취소 처리 중 오류가 발생했습니다.<br>처리 여부를 예약 상태에서 먼저 확인해주세요.');
                    }).finally(() => {
                        this.refunding = false;
                    });
                }
            });
            
        },
        CancelReservation(){

            this.$confirm('예약을 취소하시겠습니까?').then((result) => {
                if (result.isOk) {
                    const code = this.code;

                    const body = { code };
                    const req = CryptoJS.AES.encrypt( JSON.stringify(body), process.env.VUE_APP_SECRET_TOKEN).toString();

                    this.$http.post('/shop/reservation/ReservationCancel', { req }, { quiet: true }).then(
                        (res) => {
                            if(res.status == 200){
                                // this.loading = false;
                                if(res.data.code =="200"){
                                    this.GetReservation();
                                } else if (res.data.message) {
                                    this.$alert(res.data.message);
                                } else {
                                    // 2026-08-28: message 가 없는 실패코드면 아무 말이 없던 자리.
                                    this.$alert('예약 취소를 완료하지 못했습니다. 예약 상태를 확인해주세요.');
                                }
                            }

                        }
                    ).catch(() => {
                        // 2026-08-28: 네트워크 오류·500 이면 무반응이었다.
                        //   취소가 됐는지 모른 채 다시 누르면 이중 처리가 된다.
                        this.$alert('예약 취소에 실패했습니다. 잠시 후 다시 시도해주세요.');
                    });
                }
            });
            
        },
        GetReservation() {
            const code = this.code;

            const body = { code };
            const req = CryptoJS.AES.encrypt(JSON.stringify(body),process.env.VUE_APP_SECRET_TOKEN).toString();
            
            this.$http.post('/shop/reservation/GetReservationDetail', { req }).then(
                (res) => {
                    if (res.status !== 200) {
                        return;
                    }

                    if (res.data.code == '9999') {
                        this.$store.dispatch('SETLOGOUT').then(() => {
                            window.location.href = '/signin';
                        });
                        return;
                    }

                    if (res.data.code != '200' || !res.data.body) {
                        this.$alert('예약 상세 정보를 불러오지 못했습니다.');
                        return;
                    }

                    const e_body = res.data.body;
                    const bytes = CryptoJS.AES.decrypt(e_body,process.env.VUE_APP_SECRET_TOKEN);
                    const d_res = bytes.toString(CryptoJS.enc.Utf8);
                    const body = JSON.parse(d_res);

                    if (!body.info || !body.l_info) {
                        this.$alert('예약 상세 정보가 비어 있습니다.');
                        return;
                    }

                    this.info = body.info;
                    this.l_name = body.l_info.name;
                    this.l_address = body.l_info.address;
                    this.l_image_path = body.l_info.image_path;
                    const detailItemList = Array.isArray(body.item_list)
                        ? body.item_list
                        : Array.isArray(body.info.item_list)
                            ? body.info.item_list
                            : [];

                    this.item_list = detailItemList;
                    this.proxy_list = Array.isArray(body.proxy_list) ? body.proxy_list : [];
                }
            );
        },
    },
};
</script>

<style lang="scss" scoped>
#history {
  min-height: calc(100vh - 70px) !important;
  padding-bottom: 20px;
}
.badge-custom-1 {
  border: 1px solid #52c19c;
  color: #52c19c;
  line-height: 12px;
  font-weight: 600;
  background-color: #68d4ab13;
}
.gradient-danger {
  background: linear-gradient(to bottom, #fc6e51, #e9573f);
}
.gradient-success {
  background: linear-gradient(to bottom, #a0d468, #8cc152);
}
</style>
